class EnquiriesSearchController {
  constructor($scope, searchService, loadingService, enums) {
    "ngInject";

    this.$scope = $scope;
    this.searchService = searchService;
    this.loadingService = loadingService;
    this.enums = enums;
    
    this.filterParams = { };
    this.enquiries = null;

    this.$scope.$on('omniSearch:search', this.searchEnquiries.bind(this));         
  }

  reset() {
    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    this.filterParams.pageCriteria = {
      pageStart: 0,
      itemsToFetch: this.pagination.pageSize,
      sortExpression: 'created',
      ascending: false
    };    

    this.notification = {
      type: 'info',
      msg: ''
    };
  }
  
  updatePageIndex() {
    if (this.pagination.currentPage === 1) {
      this.filterParams.pageCriteria.pageStart = 0;
    }
    else {
      this.filterParams.pageCriteria.pageStart = ((this.pagination.currentPage-1) * this.pagination.pageSize);
    }
  }

  updateSort(fieldName) {
    if (this.filterParams.pageCriteria.sortExpression === fieldName) {
      this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
    }
    else {
      this.filterParams.pageCriteria.sortExpression = fieldName;
      this.filterParams.pageCriteria.ascending = true;
    }

    this.searchEnquiries();
  }

  searchEnquiries(evt, searchTerm) {    
    if (searchTerm){
      this.reset();
      this.filterParams.searchTerm = searchTerm;
    }

    this.enquiries = null;

    const ctrl = this;

    ctrl.updatePageIndex();

    ctrl.loadingService.showLoading('enquiriesList', 'Searching Enquiries ...');

    this.searchService.searchEnquiriesByReg(this.filterParams)
      .then(response => {
        ctrl.enquiries = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: `No data to display`
          }
        }
        else {
          const pageEnd = (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) < response.data.totalRecords ? (ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize) :  response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: `Currently display ${(ctrl.filterParams.pageCriteria.pageStart+1)} to ${pageEnd} out of ${ctrl.pagination.totalItems} enquiries`
          }
        }
      })
      .catch(err => {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching vehicles." + (err.data ? err.data.messageDetail : '')
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('enquiriesList');

        ctrl.onUpdate({panelName: 'enquiries', numResults: ctrl.pagination.totalItems});
      });    
  }  
}

export default EnquiriesSearchController;



// WEBPACK FOOTER //
// ./client/app/components/omniSearch/enquiriesSearch/enquiriesSearch.controller.js